module.exports = __webpack_public_path__ + "images/cool-sunglasses-gif-2.gif";